import { Alert } from 'app/models/const/alert.model';

export class RingDeals {
	static readonly type = '[DrawDeal] RingDeals';
	constructor(public file: File) {}
}

export class GetRenewalRingResults {
	static readonly type = '[DrawDeal] GetRenewalRingResults';
	constructor(public renewalLogId: number) {}
}

export class CreateDrawDealsAlert {
  static readonly type = '[DrawDeal] CreateNewSettingsAlert';
  constructor(public message: string, public level: 'error' | 'success' | 'warning' | 'info') {}
}

export class DismissDrawDealsAlert {
  static readonly type = '[DrawDeal] DismissSettingsAlert';
  constructor(public alert: Alert) {}
}
